import { useEffect, useState } from "react";
import "./../styles/search.css";
import { HashLoader } from "react-spinners";
import { IoSearch } from "react-icons/io5";
import ToastNotification, {
    showToast,
} from "../components/toasts/ToastNotification";
import { searchProduct } from "../api/search.api";
import { useNavigate } from "react-router-dom";

export const Search = () => {
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [resp, setResp] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Khám Phá Các Sản Phẩm Mới";
  }, []);

  const fetchResp = async () => {
    const normalizedQuery = query.trim();
    if (!normalizedQuery) {
      setResp([]);
      setHasSearched(false);
      return;
    }

    try {
      setLoading(true);
      const res = await searchProduct(normalizedQuery);
      if (res.success) {
        setResp(res.data.resp || []);
      }
      setHasSearched(true);
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      await fetchResp();
    }
  };

  const handleFormatPackagePrice = (packages = []) => {
    const prices = packages.map((pkg) => pkg.price || 0);
    if (!prices.length) return "0đ";

    const minPrice = Math.min(...prices).toLocaleString();
    const maxPrice = Math.max(...prices).toLocaleString();
    return minPrice === maxPrice ? `${minPrice}đ` : `${minPrice}đ ~ ${maxPrice}đ`;
  };

  const getProductPrice = (product) => {
    if (product.product_type === "topup_package") {
      return handleFormatPackagePrice(product.product_attributes?.packages || []);
    }
    return `${product.product_attributes?.price?.toLocaleString() || 0}đ`;
  };

  const getProductTypeLabel = (productType) => {
    if (productType === "game_account") return "Tài khoản game";
    if (productType === "utility_account") return "Tiện ích";
    if (productType === "gift_card") return "Gift card";
    if (productType === "topup_package") return "Nạp game mobile";
    return "Sản phẩm";
  };

  if (loading) {
    return (
      <div style={{ height: "100vh" }} className="loader-container">
        <HashLoader color="var(--hash-loader-color)" />
      </div>
    );
  }

  return (
    <section className="srp-shell">
      <ToastNotification />
      <div className="srp-container">
        <div className="srp-head">
          <h1 className="srp-title">Tìm kiếm sản phẩm</h1>
          <p className="srp-subtitle">Nhập tên sản phẩm để tìm nhanh trong kho hàng.</p>
        </div>

        <div className="srp-searchbar">
          <IoSearch className="srp-searchbar-icon" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            type="text"
            className="srp-searchbar-input"
            placeholder="Ví dụ: eFootball, Gift card, coin android..."
          />
          <button type="button" onClick={fetchResp} className="srp-searchbar-button">
            Tìm
          </button>
        </div>

        {hasSearched && (
          <p className="srp-result-meta">
            {resp.length > 0
              ? `Tìm thấy ${resp.length} sản phẩm cho "${query.trim()}".`
              : `Không tìm thấy sản phẩm nào cho "${query.trim()}".`}
          </p>
        )}

        <div className="srp-list">
          {!hasSearched && (
            <div className="srp-empty">
              <p className="srp-empty-title">Bắt đầu tìm sản phẩm bạn cần</p>
              <p className="srp-empty-subtitle">Kết quả sẽ hiển thị ngay tại đây sau khi bạn tìm kiếm.</p>
            </div>
          )}

          {hasSearched &&
            resp.length > 0 &&
            resp.map((prod) => (
              <button
                key={prod._id}
                onClick={() => navigate(`/product/${prod.product_slug}`)}
                className="srp-card"
                type="button"
              >
                <img className="srp-card-image" src={prod.product_imgs?.[0]} alt={prod.product_name} />
                <div className="srp-card-body">
                  <div className="srp-card-top">
                    <p className="srp-card-name">{prod.product_name}</p>
                    <span className="srp-card-type">{getProductTypeLabel(prod.product_type)}</span>
                  </div>
                  <div className="srp-card-bottom">
                    <p className="srp-card-price">{getProductPrice(prod)}</p>
                    <p className="srp-card-sold">
                      {Number(prod.product_sold_amount || 0) > 0
                        ? `Đã bán ${Number(prod.product_sold_amount || 0)}`
                        : "Mới"}
                    </p>
                  </div>
                </div>
              </button>
            ))}

          {hasSearched && resp.length === 0 && (
            <div className="srp-empty">
              <p className="srp-empty-title">Không có kết quả phù hợp</p>
              <p className="srp-empty-subtitle">Thử lại với từ khóa khác ngắn gọn hơn hoặc gần tên sản phẩm hơn.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
